import { ShopifyStorefrontClient } from '../api/shopify/ShopifyStorefrontClient';
import { transformStorefrontCartToJbCart } from '../utils/cart/transformStorefrontCartToJbCart';
import { drawCart } from '../utils/legacyCart';

interface PreezieItem {
  id: string;
  quantity: number;
}

const storefrontClient = new ShopifyStorefrontClient();

export const initPreezieAddToCart = () => {
  let isEventListenerAdded = false;
  const PrzObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes && !isEventListenerAdded) {
        const przWidget = document.getElementsByClassName('preezie-widget-app')[0];
        if (przWidget) {
          przWidget.addEventListener('przAddToCartEvent', async (event: any) => {
            const items = event.detail.map((item: { id: string; quantity: number }) => ({
              id: item.id,
              quantity: 1,
            }));
            if (!items.length) return;
            const cart = await storefrontClient.addMultipleToCart(
              items.map((item: PreezieItem) => ({ variantId: item.id, quantity: item.quantity }))
            );
            const transformedCart = transformStorefrontCartToJbCart(cart);
            await drawCart(transformedCart);
          });
          isEventListenerAdded = true;
        }
      }
    });
  });

  PrzObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  });
};
